<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>

import PaymentService from "@/services/PaymentService";
import UtilService from "@/services/UtilService";

export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push(`/apps/payments/edit/${this.params.data.Id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Are you sure you want to delete payment of Rs ${this.params.data.Amount} for ${this.params.data.Partner}?`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      PaymentService.delete(this.params.data.Id)
        .then(() => {
          UtilService.notifySuccessAlert(this.$vs, 'The selected record was successfully deleted.');
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
}
</script>
